import { FormikProps } from "formik";
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
} from "../select/Select";
import ValidationErrorMessage from "./ValidationErrorMessage";
import IsRequired from "./common/IsRequired";

export function SelectFormik<U>({
  config,
  data,
  formik,
  additionalOnChange,
  disabled,
  triggerClassName,
  clearable,
}: {
  config: Omit<ISelect<U>, "initialValue">;
  formik: FormikProps<any>;
  data: string[] | LabelValueType[];
  disabled?: boolean;
  additionalOnChange?: () => void;
  triggerClassName?: string;
  clearable?: boolean;
}) {
  const { setFieldTouched, setFieldValue, touched, errors, values } = formik;
  const { id, placeholder, label, isRequired } = config;
  const items: LabelValueType[] = data.map((item: string | LabelValueType) => {
    if (typeof item === "string") return { label: item, value: item };
    return item;
  });

  return (
    <>
      <Select
        value={
          typeof values[id] === "boolean"
            ? values[id]
              ? "true"
              : "false"
            : values[id]
        }
        onValueChange={(value) => {
          if (value === "__clear__") {
            setFieldValue(id, "", true);
            setFieldTouched(id, undefined, false);
            return;
          }
          setFieldValue(id, value, true);
          setFieldTouched(id, undefined, false);
          if (additionalOnChange) additionalOnChange();
        }}
        disabled={disabled}
      >
        <label className="form-label">
          {label}
          {isRequired && <IsRequired />}
        </label>
        <SelectTrigger
          className={`${triggerClassName}${
            touched[id] && (errors as any)[id] ? " is-invalid" : ""
          }`}
          placeholder={placeholder}
        />
        <SelectContent>
          {clearable && <SelectItem value="__clear__"> </SelectItem>}
          {items.map((item, i) => (
            <SelectItem key={i} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <ValidationErrorMessage
        touched={touched[id]}
        errorMessage={(errors as any)[id]}
      />
    </>
  );
}
